<template>
  <div id="app">
    <router-view></router-view>
    <a href="https://fusionwork.sf-express.com/static-contact-desk/?appId=fe88989ceb6147438dfc62f900dea01d&appSecret=b30d59b709474f8b8368fb3386317c6d" target="_blank">
    <img class="i1con" src="static/call.png" alt="Icon" style="width: 60px; height: auto;">
    </a>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
}
.i1con {
  position: fixed;
  bottom: 50px;
  right: 30px;
  /* 其他样式 */
}
</style>



// WEBPACK FOOTER //
// src/App.vue